import '../../Default.css'
import './Service.css'
import { Flex } from "antd"
import { FC } from "react"
import { services } from "../../contents/services"
import { useResponxiveContext } from "../../context/responsive-context"
import { ServiceCategory } from "../../types"
import { ServiceCard } from "./ServiceCard"


export const Services: FC<{ category: ServiceCategory }> = ({ category }) => {
  const { useVertical } = useResponxiveContext()

  return (
    <>
    {useVertical ?
      <>
      {services[category].services.map(s =>
      <div className="Default-container Services-container">
            <Flex className="Service-card-container-vertical" justify={'start'} align={'center'} vertical>
                <ServiceCard
                  key={s.id}
                  {...s}
                 />
            </Flex>
      </div>
      )}
      </>
      :
      <div className="Default-container Services-container">
        <Flex className="Services-body" align={'center'}>
          <div className="Service-card-container">
            <Flex justify={'space-evenly'}>
              {services[category].services.map(s =>
                <ServiceCard
                  key={s.id}
                  {...s}
                 />
              )}
            </Flex>
          </div>
        </Flex>
      </div>
    }
    </>
  )
}
